module.exports = __webpack_public_path__ + "media/images/icons/energie-icons-search-880f6e8a80df3a54910fcd11e6a84f15.svg";